import React, { useState } from 'react';
import './product-offers-filter.scss';
import ProductOffersDropdown from 'components/product/product-offers-dropdown/product-offers-dropdown';

interface ProductOffersFilterProps {
    badgesCount: {
        freeDelivery: number;
        delivery24h: number;
        rates: number;
        fastPayment: number;
        isAuthorized: number;
    };
    onFilterChange: (activeFilters: string[]) => void;
}

const ProductOffersFilter: React.FC<ProductOffersFilterProps> = ({ badgesCount, onFilterChange }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selected, setSelected] = useState<string[]>([]);
    const dropdownList = [
        {
            label: `Autoryzowane sklepy (${badgesCount.isAuthorized})`,
            isActive: Boolean(badgesCount.isAuthorized),
            value: 'is_authorized',
            gtm: 'gtm_oflt_auth'
        },
        {
            label: `Darmowa dostawa (${badgesCount.freeDelivery})`,
            isActive: Boolean(badgesCount.freeDelivery),
            value: 'badge_free_delivery',
            gtm: 'gtm_oflt_fs'
        },
        {
            label: `Wysyłka w 24h (${badgesCount.delivery24h})`,
            isActive: Boolean(badgesCount.delivery24h),
            value: 'badge_delivery_24h',
            gtm: 'gtm_oflt_w24'
        },
        {
            label: `Raty (${badgesCount.rates})`,
            isActive: Boolean(badgesCount.rates),
            value: 'badge_rates',
            gtm: 'gtm_oflt_rt'
        },
        {
            label: `Szybkie płatności (${badgesCount.fastPayment})`,
            isActive: Boolean(badgesCount.fastPayment),
            value: 'badge_fast_payments',
            gtm: 'gtm_oflt_fp'
        }
    ];

    const onToggle = (): void => {
        setIsOpen(!isOpen);
    };

    const onSelect = (value: string): void => {
        const selectedArray: string[] = [...selected];
        const selectedIndex = selectedArray.findIndex(item => item === value);

        if (selectedIndex === -1) {
            selectedArray.push(value);
        } else {
            selectedArray.splice(selectedIndex, 1);
        }

        setSelected(selectedArray);
        onFilterChange(selectedArray);
        setIsOpen(false);
    };

    const onBlur = (event: React.FocusEvent<HTMLElement>): void => {
        const currentElement = event.currentTarget;

        setTimeout(() => {
            if (!currentElement.contains(document.activeElement)) {
                setIsOpen(false);
            }
        }, 100);
    };

    const clear = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
        event.stopPropagation();
        setSelected([]);
        onFilterChange([]);
    };

    return (
        <div className="product-offers-filter">
            <ProductOffersDropdown
                onBlur={onBlur}
                onToggle={onToggle}
                isOpen={isOpen}
                dropdownList={dropdownList}
                value={selected}
                onSelect={onSelect}
                title={'Pokaż oferty, które mają:'}
                multi={true}
                onClose={(): void => setIsOpen(false)}
            >
                <i className="icon-main icon-filter"/>
                {''}
                    Filtruj
                {selected.length > 0 && ` (${selected.length})`}
                {selected.length > 0
                    ? (
                        <i
                            className="product-offers-filter__clear-icon icon-clear"
                            role="button"
                            tabIndex={0}
                            aria-label={'Usuwanie aktywnych filtrów'}
                            onClick={clear}
                        />)
                    : <i className={isOpen ? 'icon-arr1-up' : 'icon-arr1-down'}/>}
            </ProductOffersDropdown>
        </div>
    );
};

export default ProductOffersFilter;
